// extracted by mini-css-extract-plugin
export default {"wrap":"RemoteReset_wrap__cE7+6","tipWrap":"RemoteReset_tipWrap__lZ4he","tipIcon":"RemoteReset_tipIcon__Ybmmz"};